import { createReducer } from 'redux-act';

import {
  ACTIONS_NAMES_DICT,
  ENTITY_ACTIONS as ACTIONS,
} from 'state/actions/satellites';

import defaultReducer from './default';

const reducerOptions = defaultReducer({ ACTIONS_NAMES_DICT, ACTIONS });
const { reducerShape, initialState } = reducerOptions;
export const satellitesReducer = createReducer(reducerShape, initialState);
